import React, { useEffect, useState } from 'react';

const loadingMessages = [
  'Verificando credenciales...',
  'Cargando invitación...',
  'Preparando entorno seguro...',
  'Preparando entorno seguro...',
  'Preparando entorno seguro...',
];

function LinkInvitationStepDefault() {
  const [messageIndex, setMessageIndex] = useState( 0 );

  useEffect( () => {
    const interval = setInterval( () => {
      setMessageIndex( ( prev ) => ( prev + 1 ) % loadingMessages.length );
    }, 2500 );

    return () => clearInterval( interval );
  }, [] );

  return (
    <>
      <h2 className="text--black4 mt-3">Cargando invitación</h2>
      <p className="text--gray20 mt-5 pt-2">
        {loadingMessages[messageIndex]}
      </p>
      <p className="mt-5 pt-2" />
    </>
  );
}

export default LinkInvitationStepDefault;
